import getDecorators from "inversify-inject-decorators";
import { container } from "./container";
var lazyInject = getDecorators(container).lazyInject;
export { lazyInject };
